module.exports = __webpack_public_path__ + "static/sidemail-email-marketing-video-thumbnail-fc3f1274b9a4bc217de94f67cf3f9ca1.png";